var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYandexmap = function SvgYandexmap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.361 1.813c-5.98 0-10.828 4.868-10.828 10.874 0 3.003 1.21 5.72 3.17 7.689 1.96 1.968 6.576 4.818 6.846 7.808.04.449.364.816.812.816.449 0 .772-.367.813-.816.27-2.99 4.887-5.84 6.846-7.808a10.863 10.863 0 0 0 3.17-7.689c0-6.006-4.848-10.874-10.829-10.874Z",
    fill: "#F43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.362 16.494a3.798 3.798 0 0 0 3.79-3.806 3.798 3.798 0 0 0-3.79-3.806 3.798 3.798 0 0 0-3.79 3.806 3.798 3.798 0 0 0 3.79 3.806Z",
    fill: "#fff"
  })));
};
export default SvgYandexmap;